const dataURLToBlob = (dataUrl: string): Blob => {
    const dataUrlArray = dataUrl.split(',');
    const mime = dataUrlArray[0].match(/^data:(.*?);/)![1];
    const byteString = atob(dataUrlArray[1]);
    let byteStringLength = byteString.length;
    const u8arr = new Uint8Array(byteStringLength);

    while (byteStringLength--) {
        u8arr[byteStringLength] = byteString.charCodeAt(byteStringLength);
    }

    return new Blob([u8arr], { type: mime });
};

const compressImage = (img: HTMLImageElement, uniqueName: string): File => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    // Set desired output dimensions, ensuring no increase in size
    const outputWidth = Math.min(img.width, Math.max(img.width * 0.5, 200)); // Reduce width but not below 200 pixels
    const outputHeight = Math.min(img.height, Math.max(img.height * 0.5, 200)); // Reduce height but not below 200 pixels

    canvas.width = outputWidth;
    canvas.height = outputHeight;

    context.drawImage(img, 0, 0, outputWidth, outputHeight);

    // Convert canvas to a data URL with JPEG compression for better size reduction
    const quality = 0.8; // Set JPEG quality to 80%
    const newImageUrl = context.canvas.toDataURL('image/jpeg', quality);

    const blob = dataURLToBlob(newImageUrl);

    return new File([blob], `${uniqueName}.jpeg`, { type: 'image/jpeg' });
};

const processImage = (
    image: HTMLImageElement,
    uniqueName: string,
    size: number,
    originalFile: File
): File => {
    const minDimension = 200; // Minimum dimension to avoid further reduction
    const maxSmallFileSize = 1024 * 1024; // 1 MB file size threshold

    // Check if image is already small
    if (image.width <= minDimension && image.height <= minDimension) {
        console.log('Image is already small enough, skipping resizing.');
        return originalFile;
    }

    // Check if file size is already small
    if (size <= maxSmallFileSize) {
        console.log('Image file size is already small enough, skipping compression.');
        return originalFile;
    }

    return compressImage(image, uniqueName);
};

export { processImage };
